import { connect } from 'react-redux';
import { upload, updateCertificate, remove } from 'store/modules/certificates';
import { compose } from 'utils/react';
import CertSettings from '../components/CertSettings';

export default compose(
  connect(
    ({ certificates, hostnames }) => ({
      certificates: certificates.items,
      isSaving: !!certificates.saving,
      errors: certificates.errors,
      hostnames: hostnames.items,
    }),
    {
      onSave: upload, onDelete: remove, updateCertificate,
    },
  ),
)(CertSettings);
